import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as WebSocket from '@app/store/features/web-socket/web-socket.reducer';

export const getState = createFeatureSelector<WebSocket.State>('ws');

export const getConnectionStatus = createSelector(
    getState,
    (state) => state.status
);
